import React from "react";
import {connect} from "react-redux";
import Profile from "./Profile";
import {addPost, putProfile, putStatus, setImageProfile, setProfile, setStatus} from "../../Redux/profileReducer";
import {setActivePageSite} from "../../Redux/authReducer";
import {addWaitingSubscribe, follow, getFollow, unFollow} from "../../Redux/usersReducer";
import Preloader from "../../Utilits/Preloader/Preloader";


class ProfileContainer extends React.Component {
    componentDidMount() {
        let id = this.props.match.params.id;
        if (!id) {
            id = this.props.id;
            if (!id) {
                this.props.history.push('/login');
            }
        }
        this.props.setProfile(id);
        this.props.setStatus(id);
        this.props.setActivePageSite("PROFILE");
        this.props.getFollow(id)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.id !== this.props.match.params.id && !this.props.match.params.id) {
            this.props.setProfile(this.props.id);
            this.props.setStatus(this.props.id);
        }
        if (prevProps.match.params.id !== this.props.match.params.id && this.props.match.params.id) {
            this.props.setProfile(this.props.match.params.id);
            this.props.setStatus(this.props.match.params.id);
        }
        if (prevProps.isAuth !== this.props.isAuth) {
            this.props.history.push('/login')
        }
    }

    render() {
        return(
            <>
                {!this.props.profile ? <Preloader/> : null}
                <Profile posts={this.props.posts}
                         profile={this.props.profile}
                         status={this.props.status}
                         putStatus={this.props.putStatus}
                         putProfile={this.props.putProfile}
                         setImageProfile={this.props.setImageProfile}
                         addPost={this.props.addPost}
                         isOwner={!this.props.match.params.id}
                         follow={this.props.follow}
                         unFollow={this.props.unFollow}
                         activeUserFollowed={this.props.activeUserFollowed}
                         waitingSubscripe={this.props.waitingSubscripe}
                />
            </>
        )
    }
}


let mapStateToProps = (state) => {
    return {
        posts: state.profilePage.posts,
        profile: state.profilePage.profile,
        status: state.profilePage.status,
        id: state.auth.id,
        isAuth: state.auth.isAuth,
        activeUserFollowed: state.usersPage.activeUserFollowed,
        waitingSubscripe: state.usersPage.waitingSubscripe,
        themeIsDark: state.appReducer.themeIsDark
    }
};

export default connect(mapStateToProps, {setProfile,
    setStatus, putStatus, putProfile, setImageProfile,
    addPost, setActivePageSite,
    follow, unFollow, getFollow, addWaitingSubscribe})(ProfileContainer);